import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './CgmAppLayout.css';

const SECTION_ADMIN = 'admin';

/** Icônes SVG (indépendantes de Font Awesome) */
const SidebarIcon = ({ name }) => {
  const common = {
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true,
    className: 'cgm-sidebar-svg',
  };
  switch (name) {
    case 'users':
      return (
        <svg {...common}>
          <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="currentColor" />
        </svg>
      );
    case 'building':
      return (
        <svg {...common}>
          <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" fill="currentColor" />
        </svg>
      );
    case 'wallet':
      return (
        <svg {...common}>
          <path d="M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28c.59-.35 1-.98 1-1.72V9c0-.74-.41-1.37-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z" fill="currentColor" />
          <circle cx="16" cy="12" r="1.5" fill="currentColor" />
        </svg>
      );
    case 'register':
      return (
        <svg {...common}>
          <path d="M2 17h20v2H2v-2zm1.15-4.05L4 11.47l.85 1.48 1.3-.75-.85-1.48H7v-1.5H5.3l.85-1.47L4.85 7 4 8.47 3.15 7l-1.3.75.85 1.47H1v1.5h1.7l-.85 1.48 1.3.75zM9.5 6H21v1.5H9.5V6zm0 3H21v1.5H9.5V9zm0 3H21V13.5H9.5V12z" fill="currentColor" />
        </svg>
      );
    case 'shield':
      return (
        <svg {...common}>
          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" fill="currentColor" />
        </svg>
      );
    case 'chart-line':
      return (
        <svg {...common}>
          <path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z" fill="currentColor" />
        </svg>
      );
    case 'cog':
      return (
        <svg {...common}>
          <path d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.6-.22l-2.39.96a7.07 7.07 0 0 0-1.63-.94l-.36-2.54A.5.5 0 0 0 13.9 2h-3.8a.5.5 0 0 0-.49.42l-.36 2.54c-.58.23-1.12.54-1.63.94l-2.39-.96a.5.5 0 0 0-.6.22L2.71 8.44a.5.5 0 0 0 .12.64l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58a.5.5 0 0 0-.12.64l1.92 3.32c.13.22.4.31.6.22l2.39-.96c.5.4 1.05.71 1.63.94l.36 2.54c.05.24.25.42.49.42h3.8c.24 0 .44-.18.49-.42l.36-2.54c.58-.23 1.12-.54 1.63-.94l2.39.96c.22.09.47 0 .6-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58zM12 15.5A3.5 3.5 0 1 1 12 8a3.5 3.5 0 0 1 0 7.5z" fill="currentColor" />
        </svg>
      );
    case 'users-cog':
      return (
        <svg {...common}>
          <path d="M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z" fill="currentColor" />
        </svg>
      );
    case 'logout':
      return (
        <svg {...common}>
          <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" fill="currentColor" />
        </svg>
      );
    case 'sun':
      return (
        <svg {...common}>
          <path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM1 13h3v-2H1v2zm10-9h2V1h-2v3zm9.04.64l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zM17.24 18.16l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 11v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16h2v-3h-2v3zm-6.17-3.24l-1.79 1.79 1.41 1.41 1.79-1.8-1.41-1.4z" fill="currentColor" />
        </svg>
      );
    case 'moon':
      return (
        <svg {...common}>
          <path d="M12.01 21c-4.97 0-9-4.03-9-9 0-3.93 2.53-7.27 6.05-8.5-.35.85-.55 1.78-.55 2.75 0 3.87 3.13 7 7 7 1.03 0 2.01-.22 2.89-.61C17.7 17.21 15.12 21 12.01 21z" fill="currentColor" />
        </svg>
      );
    case 'chevron-down':
      return (
        <svg {...common} className="cgm-sidebar-svg cgm-sidebar-chevron">
          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" fill="currentColor" />
        </svg>
      );
    case 'chevron-up':
      return (
        <svg {...common} className="cgm-sidebar-svg cgm-sidebar-chevron">
          <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" fill="currentColor" />
        </svg>
      );
    case 'chevron-left':
      return (
        <svg {...common} className="cgm-sidebar-svg cgm-sidebar-chevron">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" fill="currentColor" />
        </svg>
      );
    case 'chevron-right':
      return (
        <svg {...common} className="cgm-sidebar-svg cgm-sidebar-chevron">
          <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12l-4.58 4.59z" fill="currentColor" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="8" fill="currentColor" />
        </svg>
      );
  }
};

function NavItem({ icon, label, to, isActive, onNavigate }) {
  return (
    <a
      href={to}
      className={`cgm-app-sidebar__item${isActive ? ' is-active' : ''}`}
      title={label}
      onClick={(e) => {
        if (e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        onNavigate(to);
      }}
    >
      <span className="cgm-app-sidebar__item-icon" aria-hidden="true">
        <SidebarIcon name={icon} />
      </span>
      <span className="cgm-app-sidebar__label">{label}</span>
    </a>
  );
}

function AdminSection({
  isOpen,
  onToggle,
  collapsed,
  flyoutOpen,
  onFlyoutToggle,
  children,
  isActive,
}) {
  const handleClick = () => {
    if (collapsed) {
      onFlyoutToggle(SECTION_ADMIN);
    } else {
      onToggle();
    }
  };

  return (
    <div
      className={`cgm-app-sidebar__section${isOpen && !collapsed ? ' is-open' : ''}${flyoutOpen ? ' is-flyout-open' : ''}${isActive ? ' is-section-active' : ''}`}
    >
      <button
        type="button"
        className="cgm-app-sidebar__section-toggle"
        onClick={handleClick}
        aria-expanded={collapsed ? flyoutOpen : isOpen}
        aria-controls="sidebar-section-admin"
        title="Administration"
      >
        <span className="cgm-app-sidebar__section-icon" aria-hidden="true">
          <SidebarIcon name="shield" />
        </span>
        <span className="cgm-app-sidebar__label cgm-app-sidebar__section-title">Administration</span>
        <span className="cgm-app-sidebar__section-chevron-wrap" aria-hidden="true">
          <SidebarIcon name={isOpen ? 'chevron-up' : 'chevron-down'} />
        </span>
      </button>
      {!collapsed && (
        <div id="sidebar-section-admin" className="cgm-app-sidebar__section-body">
          <div className="cgm-app-sidebar__section-inner">{children}</div>
        </div>
      )}
      {collapsed && flyoutOpen && (
        <div className="cgm-app-sidebar__flyout" role="menu" aria-label="Administration">
          <div className="cgm-app-sidebar__flyout-title">Administration</div>
          <div className="cgm-app-sidebar__flyout-body">{children}</div>
        </div>
      )}
    </div>
  );
}

export default function CgmAppSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, isAdmin, activeCabinet } = useAuth();
  const path = location.pathname;
  const cabinetSuffix = activeCabinet?.is_default || Number(activeCabinet?.id) === 1 ? 'CGM1' : 'CGM2';
  const caisseLabel = `Retrait ${cabinetSuffix}`;
  const [adminOpen, setAdminOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem('gestionCAIS_sidebar_collapsed') === 'true'
  );
  const [openFlyout, setOpenFlyout] = useState(null);
  const sidebarRef = useRef(null);

  useEffect(() => {
    localStorage.setItem('gestionCAIS_sidebar_collapsed', collapsed);
    if (collapsed) setOpenFlyout(null);
  }, [collapsed]);

  useEffect(() => {
    if (!openFlyout) return undefined;
    const handleClickOutside = (e) => {
      if (!sidebarRef.current?.contains(e.target)) setOpenFlyout(null);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [openFlyout]);

  useEffect(() => {
    if (path === '/comptes') setAdminOpen(true);
  }, [path]);

  const isActive = (matchers) => {
    const list = Array.isArray(matchers) ? matchers : [matchers];
    return list.some((m) => (typeof m === 'function' ? m(path) : path === m));
  };

  const isAdminSectionActive = isActive((p) => p === '/comptes');

  const go = (to) => {
    setOpenFlyout(null);
    navigate(to);
  };

  const handleFlyoutToggle = (sectionId) => {
    setOpenFlyout((prev) => (prev === sectionId ? null : sectionId));
  };

  const toggleCollapsed = () => {
    setOpenFlyout(null);
    setCollapsed((v) => !v);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <aside
      ref={sidebarRef}
      className={`cgm-app-sidebar${collapsed ? ' cgm-app-sidebar--collapsed' : ''}`}
      aria-label="Menu principal"
    >
      <nav className="cgm-app-sidebar__nav">
        {isAdmin() && (
          <NavItem
            icon="chart-line"
            label="Tableau de bord"
            to="/dashboard"
            isActive={isActive((p) => p === '/dashboard' || p === '/admin/dashboard')}
            onNavigate={go}
          />
        )}

        <NavItem
          icon="users"
          label="Gérer client"
          to="/clients"
          isActive={isActive((p) => p === '/clients')}
          onNavigate={go}
        />

        <NavItem
          icon="register"
          label={caisseLabel}
          to="/caisse-cgm"
          isActive={isActive((p) => p.startsWith('/caisse-cgm'))}
          onNavigate={go}
        />

        <NavItem
          icon="building"
          label={`État ${cabinetSuffix}`}
          to="/etat-bureau/toutes"
          isActive={isActive((p) => p.startsWith('/etat-bureau'))}
          onNavigate={go}
        />

        <NavItem
          icon="wallet"
          label={`Fond client chez ${cabinetSuffix}`}
          to="/fond-client-cgm"
          isActive={isActive((p) => p.startsWith('/fond-client-cgm'))}
          onNavigate={go}
        />

        {isAdmin() && (
          <AdminSection
            isOpen={adminOpen}
            onToggle={() => setAdminOpen((v) => !v)}
            collapsed={collapsed}
            flyoutOpen={openFlyout === SECTION_ADMIN}
            onFlyoutToggle={handleFlyoutToggle}
            isActive={isAdminSectionActive}
          >
            <NavItem
              icon="users-cog"
              label="Gérer users"
              to="/comptes"
              isActive={isActive((p) => p === '/comptes')}
              onNavigate={go}
            />
          </AdminSection>
        )}
      </nav>

      <div className="cgm-app-sidebar__bottom">
        <button
          type="button"
          className="cgm-app-sidebar__item cgm-app-sidebar__item--logout"
          onClick={handleLogout}
          title="Déconnexion"
        >
          <span className="cgm-app-sidebar__item-icon" aria-hidden="true">
            <SidebarIcon name="logout" />
          </span>
          <span className="cgm-app-sidebar__label">Déconnexion</span>
        </button>

        <button
          type="button"
          className="cgm-app-sidebar__collapse-btn"
          onClick={toggleCollapsed}
          title={collapsed ? 'Développer le menu' : 'Réduire le menu'}
          aria-label={collapsed ? 'Développer le menu' : 'Réduire le menu'}
        >
          <SidebarIcon name={collapsed ? 'chevron-right' : 'chevron-left'} />
          <span className="cgm-app-sidebar__label">Menu</span>
        </button>
      </div>
    </aside>
  );
}
